import { MDBTextArea } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";
import { validatePhoneNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

function LocNineOOContacts({ register, setValue, getValues, errors, watch }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="routing-border mt-2"></div>
      <div className="general-settings">{t("Contacts")}</div>
      <div className="add-numbermain">
        <div>{t("Name")}</div>
        <div class="flex-column-sm d-flex w-30">
          <div class="me-2 w-100">
            <label className="float-left">{t("firstName")}</label>
            <input
            maxLength={30}
              type="text"
              className="form-control"
              {...register("primary_contact.fname",{required : "First Name is required"})}
            />
            {errors.primary_contact?.fname && (
              <p className="text-danger">
                {errors.primary_contact.fname.message}
              </p>
            )}
          </div>
          <div class="w-100">
            <label className="float-left">{t("lastName")}</label>
            <input
              type="text"
              maxLength={20}
              className="form-control"
              {...register("primary_contact.lname",{required :"Last Name is required"})}
            />
            {errors.primary_contact?.lname && (
              <p className="text-danger">
                {errors.primary_contact.lname.message}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("email_address")}</div>
        <div className="d-flex w-30">
          <div className="form-outline w-100">
            <input
              type="text"
              className="form-control w-100"
              {...register("primary_contact.email")}
            />
            {errors.primary_contact?.email && (
              <p className="text-danger">
                {errors.primary_contact.email.message}
              </p>
            )}
          </div>
        </div>
      </div>
      {/* <div className="add-numbermain">
        <div className="tel-numbers">{t("Number")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <input
              type="text"
              className="form-control w-100"
              {...register("primary_contact.number", {validate: validatePhoneNumber})}
            />
            {errors.primary_contact?.number && (
              <p className="text-danger">
                {errors.primary_contact.number.message}
              </p>
            )}
          </div>
        </div>
      </div> */}

      <div className="add-numbermain">
        <div>
          <div className="tel-numbers">{t("AdditionalEmailsnotif")}</div>
          <span className="phrecording">{t("AdditionalEmailsnotiftxt")}</span>
        </div>

        <div className="d-flex w-30">
          <MDBTextArea
            className="w-100"
            rows={2}
            value={watch("primary_contact.additional_emails")}
            onChange={(e) => {
              setValue(
                "primary_contact.additional_emails",
                e.target.value,
                { shouldDirty: true }
              );
            }}
          />
          {errors.primary_contact?.additional_emails && (
            <p className="text-danger">
              {errors.primary_contact.additional_emails.message}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default LocNineOOContacts;
